<form [formGroup]="formGroupFirma()">

  @if(isTestUmgebung()) {
    <div class="flex-container">
      <div style="flex: 12">
        <mat-checkbox formControlName="simuliereProd">
          {{'simuliere_prod' | translate}}
        </mat-checkbox>
        <br />
        <br />
      </div>
    </div>
  }

  <p>{{'registrierung.firmendaten.hinweis' | translate}}</p>
  <div class="flex-container">
    <div style="flex: 12">
      <label>{{'registrierung.firmendaten.label_firmenname' | translate}}</label>
      <mat-form-field>
        <input matInput formControlName="firma" placeholder="{{'registrierung.firmendaten.label_firmenname' | translate}}" />
        @if ((formGroupFirma().touched || formGroupFirma().dirty) && formGroupFirma().controls['firma'].errors) {
          <mat-error>
            <mat-icon svgIcon="basics:error"></mat-icon>
            <span>{{'registrierung.firmendaten.firmenname_pflicht' | translate}}</span>
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>

  <div class="flex-container">
    <div style="flex: 12">
      <label>{{'registrierung.firmendaten.label_steuernummer' | translate}}</label>
      <mat-form-field>
        <input matInput formControlName="steuernummer"
               placeholder="{{'registrierung.firmendaten.steuernummer_placeholder' | translate}}"
               maxlength="11" />
        @if ((formGroupFirma().touched || formGroupFirma().dirty) && formGroupFirma().controls['steuernummer'].errors) {
          <mat-error>
            <mat-icon svgIcon="basics:error"></mat-icon>
            @if (formGroupFirma().controls['steuernummer'].errors?.['invalid']) {
              <span>{{'registrierung.firmendaten.steuernummer_ungueltig' | translate}}</span>
            } @else {
              <span>{{'registrierung.firmendaten.steuernummer_pflicht' | translate}}</span>
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>

  <div class="flex-container">
    <div style="flex: 12">
      <label>{{'registrierung.firmendaten.label_telefon' | translate}}</label>
      <mat-form-field>
        <input matInput formControlName="telefon" placeholder="{{'registrierung.firmendaten.telefon_placeholder' | translate}}" />
        @if ((formGroupFirma().touched || formGroupFirma().dirty) && formGroupFirma().controls['telefon'].errors) {
          <mat-error>
            <mat-icon svgIcon="basics:error"></mat-icon>
            <span >{{'registrierung.firmendaten.telefon_pflicht' | translate}}</span>
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>


  <div class="flex-container">
    <div style="flex: 12">
      <label >{{'registrierung.firmendaten.label_adresse' | translate}}</label>
      <div>
        <app-adress-suche (adressChanged)="onAdressChanged($event)"></app-adress-suche>
      </div>
    </div>
  </div>

  @if(adresseGeprueft()) {
    <div class="flex-container">
      <div style="flex: 12">
        <p>{{'registrierung.firmendaten.adresse_ausgewaehlt' | translate}}</p>
        <div>
          <div class="adresse-selektiert" (click)="showAdresse.set(!showAdresse())">{{getOsmAdresse().strasse}} {{getOsmAdresse().hausnummer}}, {{getOsmAdresse().plz}} {{getOsmAdresse().ort}}
            <mat-icon style="vertical-align: bottom; float:right" svgIcon="basics:edit"></mat-icon>
          </div>
        </div>
      </div>
    </div>
  }

  @if(adresseGeprueft() && showAdresse()) {
    <br />
    <div class="flex-container">
      <div style="flex: 9">
        <label>{{'registrierung.firmendaten.label_strasse' | translate}}</label>
        <mat-form-field>
          <input matInput formControlName="strasse" placeholder="{{'registrierung.firmendaten.label_strasse' | translate}}" />
          @if ((formGroupFirma().touched || formGroupFirma().dirty) && formGroupFirma().controls['strasse'].errors) {
            <mat-error>
              <mat-icon svgIcon="basics:error"></mat-icon>
              <span>{{'registrierung.firmendaten.strasse_pflicht' | translate}}</span>
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div style="flex: 3">
        <label>{{'registrierung.firmendaten.label_hausnummer' | translate}}</label>
        <mat-form-field>
          <input matInput formControlName="hausnummer" placeholder="{{'registrierung.firmendaten.label_hausnummer' | translate}}" />
          @if ((formGroupFirma().touched || formGroupFirma().dirty) && formGroupFirma().controls['hausnummer'].errors) {
            <mat-error>
              <mat-icon svgIcon="basics:error"></mat-icon>
              <span>{{'registrierung.firmendaten.hausnummer_pflicht' | translate}}</span>
            </mat-error>
          }

        </mat-form-field>
      </div>
    </div>
    <div class="flex-container">
      <div style="flex: 4">
        <label>{{'registrierung.firmendaten.label_plz' | translate}}</label>
        <mat-form-field>
          <input matInput formControlName="plz" placeholder="{{'registrierung.firmendaten.label_plz' | translate}}" />
          @if ((formGroupFirma().touched || formGroupFirma().dirty) && formGroupFirma().controls['plz'].errors) {
            <mat-error>
              <mat-icon svgIcon="basics:error"></mat-icon>
              <span>{{'registrierung.firmendaten.plz_pflicht' | translate}}</span>
            </mat-error>
          }

        </mat-form-field>
      </div>
      <div style="flex: 8">
        <label>{{'registrierung.firmendaten.label_ort' | translate}}</label>
        <mat-form-field>
          <input matInput formControlName="ort" placeholder="{{'registrierung.firmendaten.label_ort' | translate}}" />
          @if ((formGroupFirma().touched || formGroupFirma().dirty) && formGroupFirma().controls['ort'].errors) {
            <mat-error>
              <mat-icon svgIcon="basics:error"></mat-icon>
              <span>{{'registrierung.firmendaten.ort_pflicht' | translate}}</span>
            </mat-error>
          }

        </mat-form-field>
      </div>
    </div>
    <div class="flex-container">
      <div style="flex: 12">
        <label>{{'registrierung.firmendaten.label_land' | translate}}</label>
        <mat-form-field>
          <mat-select formControlName="land">
            @for (land of LaenderEnums; track land) {
              <mat-option [value]="land.value">
                {{ land.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <p class="paragraph_small">{{'registrierung.firmendaten.hinweis_korrektur' | translate}}</p>

  }

</form>
